import type { JSX } from 'react';

import { useSessionQuery } from '../graphql/queries/useSessionQuery';

import styles from '../styles/ImpersonationBanner.module.css';

const formatDisplay = (fullName?: string | null, email?: string | null): string => {
  let target = '';

  if (fullName && email && fullName !== email) {
    target = `${fullName} (${email})`;
  } else {
    target = fullName ?? email ?? '';
  }

  return target ? `Impersonating ${target}` : '';
};

const ImpersonationBanner = (): JSX.Element | null => {
  const { impersonated, fullName, email, loading } = useSessionQuery();

  if (loading || !impersonated) {
    return null;
  }

  const displayText = formatDisplay(fullName, email);

  if (!displayText) {
    return null;
  }

  return (
    <>
      <div
        className={styles.impersonationBanner}
        role="status"
        aria-live="polite"
        data-testid="impersonation-banner"
      >
        <div className={styles.bannerContent}>
          <span className={styles.bannerText}>{displayText}</span>
        </div>
      </div>
      <div className={styles.bannerSpacer} aria-hidden="true" />
    </>
  );
};

export default ImpersonationBanner;
